export default __webpack_public_path__ + "static/media/js.78206ba6.png";